import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import CustomSearchDropdown from "../../Reports/components/FieldsComponent";
import "../ReviewQuestion/ReviewQuestion.css";
import EditComponentPSQ from "./EditComponentPSQ";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchCourseData } from "./../../../Redux/StudentRegistration/courseSlice";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import AddOptionDropdwon from "../ParseBulkQuestions/AddDropdownOptions";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
import DropDownUP from "../ParseBulkQuestions/Dropdown";
import DropDownUP2 from "../ParseBulkQuestions/DropdownUP2";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import katex from "katex";
import "katex/dist/katex.min.css";
import pencil from "../../../Assets/Images/CommanImages/GPenz.png";
import UndoBack from "../../../Assets/Images/CommanImages/Reset.png";
// import TestComponent from "./testReviewComponent";

const PSQMain = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
}) => {
  const [errorCount, setErrorCount] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const setId = queryParams.get("setId");
  const setNameSet = queryParams.get("setName");

  const imageFiles = [];
  const { coursesdata = [] } = useSelector((state) => state.course);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [selectedCourseLabel, setSelectedCourseLabel] = useState("");
  const [selectedDifficultyLevelLabel, setSelectedDifficultyLevelLabel] =
    useState("");
  const [globalImageCounter, setGlobalImageCounter] = useState(0); // Global image counter
  const [selectedSetName, setSelectedSetName] = useState(null);
  //   const [selectedSetId, setSelectedSetId] = useState("1398"); // Store selected ID
  // const [selectedSetId, setSelectedSetId] = useState(""); // Store selected ID
  //   const [selectedSetId, setSelectedSetId] = useState("1558"); // Store selected ID
  const [selectedSetId, setSelectedSetId] = useState("1725"); // Store selected ID
  //   const [selectedSetId, setSelectedSetId] = useState(setId); // Store selected ID
  const [setNames, setSetNames] = useState([]); // Dropdown options
  //  const  DeleteQuestion = useState(deletedQuestions);
  const [convertedHtml, setConvertedHtml] = useState("");
  const [isEditing, setIsEditing] = useState(false); // Tracks if the user is editing
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [selected, setSelected] = useState([]);
  const [showTwoInputs, setShowTwoInputs] = useState(false);
  const toggleView = () => setShowTwoInputs(!showTwoInputs);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const { coursesdata } = useSelector((state) => state.course);
  const handlePreviousButtonClick = () => {
    if (currentQuestion) {
      const currentIndex = questionsData.findIndex(
        (question) => question.question_id === currentQuestion.question_id
      );
      if (currentIndex > 0) {
        setCurrentQuestion(questionsData[currentIndex - 1]);
      }
    }
    setIsEditMode(false); // Ensure the mode is set to non-editable
    setShowTwoInputs(false); // Ensure edit inputs are hidden
  };

  const clearLocalStorage = () => {
    const keysToClear = ["POP", "NON", "TagsPOP", "ImagesPOP", "DeletePush"]; // List of keys you want to remove
    const popData = localStorage.getItem("POP"); // Retrieve the data from the "POP" key

    if (popData) {
      // Create a Blob with the POP data
      const blob = new Blob([popData], { type: "text/plain" });
      const url = URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = "Question_Not_Send_Data.txt"; // Set the file name

      // Add an event listener to clear local storage after the download is triggered
      a.addEventListener("click", () => {
        // Wait for a small delay to ensure the file is saved before clearing localStorage
        setTimeout(() => {
          keysToClear.forEach((key) => {
            localStorage.removeItem(key);
          });

          // Set the UI updates and messages
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <p style={{ marginLeft: "20px", marginTop: "4px" }}>
                  Cleared Faulty Values.
                </p>
              </div>
              <div className="messagebox-insider2"></div>
            </div>
          );
          setActiveImg(ErrorImg);
        }, 100); // Adjust the delay as needed
      });

      document.body.appendChild(a); // Append the anchor to the body
      a.click(); // Trigger the download
      document.body.removeChild(a); // Clean up the anchor element
      URL.revokeObjectURL(url); // Revoke the object URL to free memory
    } else {
      // If no POP data exists, clear local storage immediately
      keysToClear.forEach((key) => {
        localStorage.removeItem(key);
      });

      // Set the UI updates and messages
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <p style={{ marginLeft: "20px", marginTop: "4px" }}>
              Cleared Faulty Values.
            </p>
          </div>
          <div className="messagebox-insider2"></div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  // const clearLocalStorage = () => {
  //     const keysToClear = ["POP", "NON", "TagsPOP", "ImagesPOP", "DeletePush"]; // List of keys you want to remove
  //     const popData = localStorage.getItem("POP"); // Retrieve the data from the "POP" key

  //     // Check if "POP" data exists before creating the file
  //     if (popData) {
  //       // Create a Blob with the POP data
  //       const blob = new Blob([popData], { type: "text/plain" });
  //       const url = URL.createObjectURL(blob);

  //       // Create a temporary anchor element to trigger the download
  //       const a = document.createElement("a");
  //       a.href = url;
  //       a.download = "Question_Not_Send_Data.txt"; // Set the file name
  //       a.click();

  //       // Revoke the object URL to free memory
  //       URL.revokeObjectURL(url);
  //     }

  //     // Clear the specified keys from localStorage
  //     keysToClear.forEach((key) => {
  //       localStorage.removeItem(key);
  //     });

  //     // Set the UI updates and messages
  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <p style={{ marginLeft: "20px", marginTop: "4px" }}>
  //             Cleared Faulty Values.
  //           </p>
  //         </div>
  //         <div className="messagebox-insider2"></div>
  //       </div>
  //     );
  //     setActiveImg(ErrorImg);
  //   };

  const handleImageClick = () => {
    setIsEditMode(!isEditMode);
    setCurrentQuestion(currentQuestion);
    toggleView();
  };

  useEffect(() => {
    // Initialize the counter based on existing images in localStorage
    const storedImages = JSON.parse(localStorage.getItem("ImagesPOP")) || {};
    let maxCounter = 0;

    // Find the highest image number across all questions
    Object.values(storedImages).forEach((images) => {
      images.forEach((img) => {
        const match = img.name.match(/image(\d+)\.png/);
        if (match) {
          const number = parseInt(match[1], 10);
          if (number > maxCounter) maxCounter = number;
        }
      });
    });

    setGlobalImageCounter(maxCounter);
  }, []);

  useEffect(() => {
    if (selectedSetId) {
      const fetchQuestionsData = async () => {
        try {
          const response = await fetch(
            `${FULL_API_BASE_URL}/get-parsed-questions-for-initial-review/?client_id=1&client_branch_id=1&parse_ques_set_id=${selectedSetId}`,
            {
              headers: {
                accept: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("other")}`,
              },
            }
          );
          const data = await response.json();
          setQuestionsData(data);

          const popData = JSON.parse(localStorage.getItem("POP")) || {};
          const nonData = JSON.parse(localStorage.getItem("NON")) || {};

          if (data.length > 0) {
            const firstQuestion = data[0];

            // Check if the first question exists in POP or NON
            if (popData[firstQuestion.question_id]) {
              setCurrentQuestion({
                ...firstQuestion,
                question_text: popData[firstQuestion.question_id].question_text,
                options: popData[firstQuestion.question_id].options,
              });
            } else if (nonData[firstQuestion.question_id]) {
              setCurrentQuestion({
                ...firstQuestion,
                question_text: nonData[firstQuestion.question_id].question_text,
                options: nonData[firstQuestion.question_id].options,
              });
            } else {
              setCurrentQuestion(firstQuestion);
            }
          }
        } catch (error) {
          console.error("Error fetching questions data:", error);
        }
      };

      fetchQuestionsData();
    }
  }, [selectedSetId]);

  const handleLatexChange = (event) => {
    const newLatex = event.target.value;
    setConvertedHtml(katex.renderToString(newLatex, { throwOnError: false }));
  };

  const handleButtonClick = (question) => {
    const popData = JSON.parse(localStorage.getItem("POP")) || {};
    const nonData = JSON.parse(localStorage.getItem("NON")) || {};

    let loadedQuestion = question;

    if (popData[question.question_id]) {
      loadedQuestion = popData[question.question_id];
    } else if (nonData[question.question_id]) {
      loadedQuestion = nonData[question.question_id];
    }

    setCurrentQuestion({
      ...question,
      question_text: loadedQuestion.question_text,
      options: loadedQuestion.options,
    });
  };

  const processText = (text) => {
    // Replace imgsrc with <img> tags
    text = text.replace(
      /imgsrc=([^ ]+)/g,
      '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
    );

    // Render LaTeX expressions
    const latexRegex = /\\\((.*?)\\\)/g;
    text = text.replace(latexRegex, (match, p1) => {
      return katex.renderToString(p1, { throwOnError: false });
    });

    return text;
  };
  const [submittedQuestions, setSubmittedQuestions] = useState([]);
  const [reviewedQuestions, setReviewedQuestions] = useState([]);
  const getButtonClass = (question) => {
    let classes = [];
    const localData = JSON.parse(localStorage.getItem("POP")) || {};

    if (
      reviewedQuestions.includes(question.question_id) ||
      // reviewedQuestions.includes(question.question_id) ||
      // question.status === 2 ||
      localData[question.question_id] // Check if question exists in localStorage
    ) {
      classes.push("blue-review-parser");
    } else if (submittedQuestions.includes(question.question_id)) {
      classes.push("grey-submitted-parser");
    } else if (deletedQuestions.includes(question.question_id)) {
      classes.push("Delete_button_overlap_RQ");
    } else {
      switch (question.status) {
        case 4:
          classes.push("grey-submitted-parser");
          break;
        case 2:
          classes.push("blue-review-parser");
          break;
        case 3:
          classes.push("Delete_button_overlap_RQ");
          break;
        case 5:
          classes.push("Delete_button_overlap_RQ-2");
          break;
        default:
          classes.push("White-Not-review-parser");
      }
    }

    if (currentQuestion?.question_id === question.question_id) {
      classes.push("current-question");
    }

    return classes.join(" ");
  };

  const [deletedQuestions, setDeletedQuestions] = useState([]);
  const [questionsData, setQuestionsData] = useState([]);
  const [isOpenTagging, setIsOpenTagging] = useState(true);
  const [isOpenUpload, setIsOpenUpload] = useState(true);
  // const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  // const [chapters, setChapters] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState(null);
  // const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [tags, setTags] = useState([]);
  const [dropdownData, setDropdownData] = useState({});
  const [value, setValues] = useState({ course_id: "" });
  const [uploadedFile, setUploadedFile] = useState(null);
  const [dropdownKey, setDropdownKey] = useState(Date.now());
  const [selectedSubjectLabel, setSelectedSubjectLabel] = useState(""); // Add this line
  const [selectedChapterLabel, setSelectedChapterLabel] = useState("");
  const [selectedTopicLabel, setSelectedTopicLabel] = useState("");
  const [topicId, setTopicId] = useState(null);
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  const accessToken = localStorage.getItem("other");
  const toggleTaggingAccordion = () => {
    setIsOpenTagging(!isOpenTagging);
  };
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
  const handleSkipReview = () => {
    const nextIndex =
      questionsData.findIndex(
        (q) => q.question_id === currentQuestion.question_id
      ) + 1;
    if (nextIndex < questionsData.length) {
      setCurrentQuestion(questionsData[nextIndex]);
    }
    setIsEditMode(false); // Ensure the mode is set to non-editable
    setShowTwoInputs(false); // Ensure edit inputs are hidden
  };

  const handleDeleteQuestion = () => {
    if (currentQuestion) {
      const deletePushData =
        JSON.parse(localStorage.getItem("DeletePush")) || {};

      if (deletedQuestions.includes(currentQuestion.question_id)) {
        // Restore question
        setDeletedQuestions(
          deletedQuestions.filter((id) => id !== currentQuestion.question_id)
        );
        delete deletePushData[currentQuestion.question_id]; // Remove from DeletePush
      } else {
        // Delete question
        setDeletedQuestions([...deletedQuestions, currentQuestion.question_id]);

        // Prepare question data for DeletePush
        const deletedQuestionData = {
          parse_ques_set_question_id: currentQuestion.question_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_ques_no: currentQuestion.ques_no,
          parse_ques_set_ques_type: currentQuestion.ques_type,
          question_text: currentQuestion.question_text,
          status: 3, // Default status for delete action
          initial_reviewed_by: userName,
          initial_reviewed_on: new Date().toISOString(),
          options: currentQuestion.options.map((option, index) => ({
            parse_ques_set_option_id: option.option_id,
            parse_ques_set_id: selectedSetId,
            parse_ques_set_question_id: currentQuestion.question_id,
            parse_ques_option_no: option.option_no || index + 1,
            parse_ques_option_bool_type: option.option_bool_type,
            option_text: option.option_text,
            parse_ques_option_correct_flag: option.option_correct_flag,
            parse_ques_option_weightage: option.option_weightage,
          })),
        };

        deletePushData[currentQuestion.question_id] = deletedQuestionData;
        localStorage.setItem("DeletePush", JSON.stringify(deletePushData));
      }
    }
  };

  const toggleUploadAccordion = () => {
    setIsOpenUpload(!isOpenUpload);
  };

  useEffect(() => {
    dispatch(fetchCourseData());
    fetchTags();
  }, [dispatch]);

  useEffect(() => {
    if (currentQuestion) {
      // Delay for Course, Subject, and Topic (500ms)
      const generalDelay = setTimeout(() => {
        // Pre-select Course
        if (Array.isArray(coursesdata) && coursesdata.length > 0) {
          const selectedCourseObj = coursesdata.find(
            (course) => course.course_id === currentQuestion.course_tag_value_id
          );
          if (selectedCourseObj) {
            setValues({ course_id: selectedCourseObj.course_id });
            setSelectedCourseLabel(selectedCourseObj.course_description); // Set course label
            setDropdownKey(Date.now());
          }
        }

        // Pre-select Subject
        if (
          currentQuestion.subject_tag_value_id &&
          Array.isArray(subjects) &&
          subjects.length > 0
        ) {
          const selectedSubjectObj = subjects.find(
            (subject) =>
              subject.subject_id === currentQuestion.subject_tag_value_id
          );
          if (selectedSubjectObj) {
            setSelectedSubject(selectedSubjectObj.subject_id);
            setSelectedSubjectLabel(selectedSubjectObj.subject_name);
          }
        }

        // Pre-select Topic
        if (
          currentQuestion.topic_tag_value_id &&
          Array.isArray(topics) &&
          topics.length > 0
        ) {
          const selectedTopicObj = topics.find(
            (topic) => topic.topic_id === currentQuestion.topic_tag_value_id
          );
          if (selectedTopicObj) {
            setTopicId(selectedTopicObj.topic_id);
            setSelectedTopicLabel(selectedTopicObj.topic_name);
          }
        }
      }, 500); // 500ms delay for general dropdowns

      // Delay for Chapter (1 second)
      const chapterDelay = setTimeout(() => {
        if (
          currentQuestion.chapter_tag_value_id &&
          Array.isArray(chapters) &&
          chapters.length > 0
        ) {
          const selectedChapterObj = chapters.find(
            (chapter) =>
              chapter.chapter_id === currentQuestion.chapter_tag_value_id
          );
          if (selectedChapterObj) {
            setSelectedChapter(selectedChapterObj.chapter_id);
            setSelectedChapterLabel(selectedChapterObj.chapter_name);
          }
        }
      }, 1000); // 1-second delay for chapters

      // Pre-select Difficulty Level
      const difficultyTag = currentQuestion.tags.find(
        (tag) => tag.tag_id === 8 // Assuming tag_id 8 represents Difficulty Level
      );
      if (difficultyTag) {
        const selectedDifficultyLevel = tags
          .find((tag) => tag.parse_tag_id === 8)
          ?.parse_tag_value.find(
            (value) => value.parse_tag_value_id === difficultyTag.tag_value_id
          );
        setDropdownData((prevData) => ({
          ...prevData,
          [difficultyTag.tag_id]: difficultyTag.tag_value_id,
        }));
        setSelectedDifficultyLevelLabel(
          selectedDifficultyLevel?.tag_value || ""
        );
      }

      // Cleanup timeouts when currentQuestion or dependencies change
      return () => {
        clearTimeout(generalDelay);
        clearTimeout(chapterDelay);
      };
    }
  }, [currentQuestion, coursesdata, subjects, chapters, topics, tags]);

  useEffect(() => {
    const fetchSetNames = async () => {
      try {
        const token = sessionStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-parse-ques-set-all/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (response.ok) {
          const formattedSetNames = data.data.map((item) => ({
            label: item.parse_ques_set_name,
            id: item.parse_ques_set_id,
          }));
          setSetNames(formattedSetNames);
        } else {
          console.error("Failed to fetch set names:", data.message);
        }
      } catch (error) {
        console.error("Error while fetching set names:", error);
      }
    };
    fetchSetNames();
  }, []);

  const fetchTags = async () => {
    try {
      const token = sessionStorage.getItem("other");
      const response = await fetch(`${FULL_API_BASE_URL}/get-parse-tags-all/`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (response.ok) {
        setTags(data.data);
      } else {
        console.error("Error fetching tags:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const fetchSubjects = async () => {
      if (value.course_id) {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${value.course_id}`
        );
        const data = await response.json();
        setSubjects(data);
        setSelectedSubjectLabel(""); // Reset the subject label
        setSelectedChapterLabel(""); // Reset the chapter label
        setSelectedTopicLabel(""); // Reset the topic label
        setTopicId(null); // Reset the topic ID
      }
    };

    fetchSubjects();
  }, [value.course_id]);

  useEffect(() => {
    const fetchChapters = async () => {
      if (selectedSubject) {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-chapters-by-subject/?subject_id=${selectedSubject}`
        );
        const data = await response.json();
        setChapters(data);
        setSelectedChapterLabel(""); // Reset the chapter label
        setSelectedTopicLabel(""); // Reset the topic label
        setTopicId(null); // Reset the topic ID
      }
    };

    fetchChapters();
  }, [selectedSubject]);

  useEffect(() => {
    const fetchTopics = async () => {
      if (selectedChapter) {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-topics-by-chapter/?chapter_id=${selectedChapter}`
        );
        const data = await response.json();
        setTopics(data);
        setSelectedTopicLabel("");
        setTopicId(null);
      }
    };

    fetchTopics();
  }, [selectedChapter]);

  const handleDropdownChange = (tag, selectedOption) => {
    setDropdownData((prevData) => ({
      ...prevData,
      [tag.parse_tag_id]: selectedOption,
    }));
  };

  const handleFileUpload = (file) => {
    setUploadedFile(file);
  };

  const prepareTags = () => {
    const selectedTags = [];

    // Add parse_ques_set_id for all tags
    const parseQuesSetId = selectedSetId;

    // Process dropdown tags
    tags
      .filter((tag) => tag.parse_tag_type === 1)
      .forEach((tag) => {
        const selectedOption = dropdownData[tag.parse_tag_id]; // Get the selected option for this tag
        if (selectedOption) {
          selectedTags.push({
            parse_ques_set_id: parseQuesSetId, // Include selectedSetId
            parse_ques_set_question_id: currentQuestion.question_id,
            parse_ques_tag_id: tag.parse_tag_id,
            parse_ques_tag_value_id: selectedOption,
          });
        }
      });

    // Process checkbox tags
    tags
      .filter((tag) => tag.parse_tag_type === 2)
      .forEach((tag) => {
        const checkbox = document.getElementById(
          `checkbox-${tag.parse_tag_id}`
        );
        if (checkbox) {
          selectedTags.push({
            parse_ques_set_id: parseQuesSetId, // Include selectedSetId
            parse_ques_set_question_id: currentQuestion.question_id,
            parse_ques_tag_id: tag.parse_tag_id,
            parse_ques_tag_value_id: checkbox.checked ? 1 : 0, // 1 if checked, 0 otherwise
          });
        }
      });

    if (value.course_id) {
      selectedTags.push({
        parse_ques_set_id: parseQuesSetId, // Include selectedSetId
        parse_ques_set_question_id: currentQuestion.question_id,
        parse_ques_tag_id: 2,
        parse_ques_tag_value_id: value.course_id,
      });
    }
    if (selectedSubject) {
      selectedTags.push({
        parse_ques_set_id: parseQuesSetId, // Include selectedSetId
        parse_ques_set_question_id: currentQuestion.question_id,
        parse_ques_tag_id: 3,
        parse_ques_tag_value_id: selectedSubject,
      });
    }
    if (selectedChapter) {
      selectedTags.push({
        parse_ques_set_id: parseQuesSetId, // Include selectedSetId
        parse_ques_set_question_id: currentQuestion.question_id,
        parse_ques_tag_id: 4,
        parse_ques_tag_value_id: selectedChapter,
      });
    }
    if (selectedTopic) {
      selectedTags.push({
        parse_ques_set_id: parseQuesSetId, // Include selectedSetId
        parse_ques_set_question_id: currentQuestion.question_id,
        parse_ques_tag_id: 5,
        parse_ques_tag_value_id: selectedTopic,
      });
    }

    return selectedTags;
  };

  const showErrorMessage = (message, fileName, content) => {
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>{message}</span>
        </div>
        <div className="messagebox-insider2">
          {fileName && content && (
            <button
              className="messagebox-cancel-btn"
              onClick={() => downloadTxtFile(fileName, content)}
            >
              Download Error
            </button>
          )}
        </div>
      </div>
    );
    setActiveImg(ErrorImg);
  };

  const downloadTxtFile = (fileName, content) => {
    const blob = new Blob([content], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUpdateQuestion = async (isSubmit = false) => {
    try {
      console.log("Starting update process...");

      // Ensure required data is available before proceeding
      const popData = JSON.parse(localStorage.getItem("POP")) || {};
      const nonData = JSON.parse(localStorage.getItem("NON")) || {};
      const tagsData = JSON.parse(localStorage.getItem("TagsPOP")) || {};
      const imagesData = JSON.parse(localStorage.getItem("ImagesPOP")) || {};
      const deletePushData =
        JSON.parse(localStorage.getItem("DeletePush")) || {};

      if (!Object.keys(popData).length && !Object.keys(nonData).length) {
        console.error("No questions data found in localStorage.");
        showErrorMessage(
          "No questions data to update. Please review some questions first."
        );
        return;
      }

      console.log("Preparing data for update...");

      const url = `${FULL_API_BASE_URL}/parse-questions/${selectedSetId}`;
      const formData = new FormData();

      formData.append("username", userName);

      // Combine POP and NON data
      const mergedData = { ...nonData, ...popData };

      Object.keys(deletePushData).forEach((questionId) => {
        deletePushData[questionId].status = isSubmit ? 5 : 3;
      });

      const quesList = [
        ...Object.keys(mergedData).map((questionId) => {
          const questionData = mergedData[questionId];
          const processedQuestionText = replaceImagesWithPlaceholders(
            questionData.question_text,
            questionId
          );

          questionData.options.forEach((option, index) => {
            option.option_text = replaceImagesWithPlaceholders(
              option.option_text,
              `${questionId}_option_${index}`
            );
          });

          return {
            parse_ques_set_question_id: questionId,
            parse_ques_set_id: selectedSetId,
            parse_ques_set_ques_no: questionData.parse_ques_set_ques_no,
            parse_ques_set_ques_type: questionData.parse_ques_set_ques_type,
            question_text: processedQuestionText,
            status: questionData.status,
            initial_reviewed_by: userName,
            initial_reviewed_on: new Date().toISOString(),
          };
        }),
        ...Object.values(deletePushData), // Append deleted questions with updated status
      ];

      formData.append("ques_list", JSON.stringify(quesList));

      // Validate options list
      const isValidNumber = (value) =>
        typeof value === "number" && !isNaN(value);

      const optionsList = Object.keys(mergedData).flatMap((questionId) => {
        return mergedData[questionId].options.map((option) => ({
          parse_ques_set_option_id: option.parse_ques_set_option_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_question_id: questionId,
          parse_ques_option_no: option.parse_ques_option_no || 0, // Default to 0 if undefined
          parse_ques_option_bool_type: isValidNumber(
            option.parse_ques_option_bool_type
          )
            ? option.parse_ques_option_bool_type
            : 0, // Default to 0 if invalid
          parse_ques_option_text: option.option_text,
          parse_ques_option_correct_flag:
            option.parse_ques_option_correct_flag || 0,
          parse_ques_option_weightage: isValidNumber(
            option.parse_ques_option_weightage
          )
            ? option.parse_ques_option_weightage
            : 1, // Default to 1 if invalid
        }));
      });

      formData.append(
        "parse_ques_set_options_list",
        JSON.stringify(optionsList)
      );

      // Collect and append image files
      const imageFiles = [];
      Object.keys(imagesData).forEach((questionId) => {
        imagesData[questionId].forEach((img) => {
          const blob = base64ToBlob(img.base64);
          imageFiles.push(new File([blob], img.name, { type: blob.type }));
        });
      });

      imageFiles.forEach((file) => {
        formData.append("files", file);
      });

      // Prepare tagging list
      const taggingList = Object.keys(mergedData).flatMap((questionId) => {
        return tagsData[questionId] || [];
      });

      formData.append("parse_ques_tagging_list", JSON.stringify(taggingList));

      console.log("Sending update request...");

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("other")}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error updating questions:", errorData);
        setErrorCount((prevCount) => prevCount + 1); // Increment error count
        showErrorMessage("Error while updating questions. Please try again.");
      } else {
        console.log("Questions updated successfully.");
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Questions updated successfully!</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);

        // Clear localStorage data
        localStorage.removeItem("POP");
        localStorage.removeItem("NON");
        localStorage.removeItem("TagsPOP");
        localStorage.removeItem("ImagesPOP");
        localStorage.removeItem("DeletePush");
        setErrorCount(0); // Reset error count on success
      }
    } catch (error) {
      console.error("Error while updating questions:", error);
      setErrorCount((prevCount) => prevCount + 1); // Increment error count
      showErrorMessage(
        "Unexpected error occurred while updating questions Try Again ."
      );
    }
  };

  const handleSubmitSelectedReview = async () => {
    try {
      // Prepare ques_list, options_list, and tagging_list
      const quesList = questionsData
        .filter((question) => question.status === 2 || question.status === 3)
        .map((question) => ({
          parse_ques_set_question_id: question.question_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_ques_no: question.ques_no,
          parse_ques_set_ques_type: question.ques_type,
          status: question.status === 2 ? 4 : 5, // Update status: 2 -> 4, 3 -> 5
          initial_reviewed_by: userName,
          initial_reviewed_on: new Date().toISOString(),
        }));

      if (quesList.length === 0) {
        alert("No reviewed questions found to submit.");
        return;
      }

      // Prepare parse_ques_set_options_list
      const optionsList = questionsData.flatMap((question) =>
        question.options.map((option) => ({
          parse_ques_set_option_id: option.option_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_question_id: question.question_id,
          parse_ques_option_no: option.option_no || 0,
          parse_ques_option_bool_type: option.option_bool_type || 0,
          parse_ques_option_correct_flag: option.option_correct_flag || 0,
          parse_ques_option_weightage: option.option_weightage || 1,
        }))
      );

      // Prepare parse_ques_tagging_list
      const taggingList = questionsData.flatMap((question) =>
        question.tags.map((tag) => ({
          parse_ques_set_id: selectedSetId,
          parse_ques_set_question_id: question.question_id,
          parse_ques_tag_id: tag.tag_id,
          parse_ques_tag_value_id: tag.tag_value_id,
        }))
      );

      // Form data for the request
      const formData = new FormData();
      formData.append("username", userName);
      formData.append("ques_list", JSON.stringify(quesList));
      formData.append(
        "parse_ques_set_options_list",
        JSON.stringify(optionsList)
      );
      formData.append("parse_ques_tagging_list", JSON.stringify(taggingList));

      const url = `${FULL_API_BASE_URL}/parse-questions/${selectedSetId}`;

      // Make the API request
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("other")}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error submitting reviewed questions:", errorData);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Error while submitting reviewed questions. Please try again.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
      } else {
        console.log("Reviewed questions submitted successfully.");
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Reviewed questions submitted successfully!</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
      }
    } catch (error) {
      console.error("Error while submitting reviewed questions:", error);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              An unexpected error occurred while submitting reviewed questions.
              Please try again.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  //   Which is more Reactive in nature You or Me ?  ans is this structure .
  // Helper function to convert base64 to Blob
  const base64ToBlob = (base64) => {
    const byteString = atob(base64.split(",")[1]);
    const mimeType = base64.split(",")[0].match(/:(.*?);/)[1];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
  };

  const convertLatexToHTML = (latex) => {
    return latex.replace(/\\\((.*?)\\\)/g, (match, p1) => {
      try {
        return katex.renderToString(p1, { throwOnError: false });
      } catch (error) {
        console.error("Error converting LaTeX:", error);
        return latex; // Return raw LaTeX on error
      }
    });
  };

  const [NewDataCOA, setNewDataCOA] = useState({});

  const fetchNewUpdatedDataValues = (newDataChild) => {
    if (!newDataChild) {
      console.error("No new data provided.");
      return null;
    }

    if (currentQuestion) {
      console.log(":: Updated values from child ::", newDataChild);
      console.log(":: Current Question ID ::", currentQuestion.question_id);

      const updatedData = {
        QuestionIDNewDataChild: currentQuestion.question_id,
        QuestionTextNewDataChild: newDataChild.question_text,
        OptionTextNewDataChild: newDataChild.options,
        ImagesNewDataChild: newDataChild.images, // Include images in updated data
      };

      setNewDataCOA(updatedData);

      // Save images to localStorage
      const existingImages =
        JSON.parse(localStorage.getItem("ImagesPOP")) || {};
      existingImages[currentQuestion.question_id] = newDataChild.images;
      localStorage.setItem("ImagesPOP", JSON.stringify(existingImages));

      console.log(":: Returning updated data ::", updatedData);
      return updatedData;
    } else {
      console.error("No current question available.");
      return null;
    }
  };
  const handleReviewAndProceed = () => {
    if (currentQuestion) {
      const popData = JSON.parse(localStorage.getItem("POP")) || {};
      const nonData = JSON.parse(localStorage.getItem("NON")) || {};
      const tagsData = JSON.parse(localStorage.getItem("TagsPOP")) || {};

      if (!isEditMode) {
        // Save to NON when not in edit mode
        const nonQuestionData = {
          parse_ques_set_question_id: currentQuestion.question_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_ques_no: currentQuestion.ques_no,
          parse_ques_set_ques_type: currentQuestion.ques_type,
          question_text: currentQuestion.question_text,
          // status: currentQuestion.status,
          status: 2,
          initial_reviewed_by: userName,
          initial_reviewed_on: new Date().toISOString(),
          options: currentQuestion.options.map((option, index) => ({
            parse_ques_set_option_id: option.option_id,
            parse_ques_set_id: selectedSetId,
            parse_ques_set_question_id: currentQuestion.question_id,
            parse_ques_option_no: option.option_no || index + 1,
            parse_ques_option_bool_type: option.option_bool_type,
            option_text: option.option_text,
            parse_ques_option_correct_flag: option.option_correct_flag,
            parse_ques_option_weightage: option.option_weightage,
          })),
        };

        nonData[currentQuestion.question_id] = nonQuestionData;
        localStorage.setItem("NON", JSON.stringify(nonData));
      } else {
        // Save to POP when in edit mode
        const popQuestionData = {
          parse_ques_set_question_id: currentQuestion.question_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_ques_no: currentQuestion.ques_no,
          parse_ques_set_ques_type: currentQuestion.ques_type,
          question_text: NewDataCOA.QuestionTextNewDataChild,
          status: 2,
          initial_reviewed_by: userName,
          initial_reviewed_on: new Date().toISOString(),
          options: NewDataCOA.OptionTextNewDataChild.map((option, index) => ({
            parse_ques_set_option_id: option.option_id,
            parse_ques_set_id: selectedSetId,
            parse_ques_set_question_id: currentQuestion.question_id,
            parse_ques_option_no: option.option_no || index + 1,
            parse_ques_option_bool_type: option.option_bool_type,
            option_text: option.option_text,
            parse_ques_option_correct_flag: option.option_correct_flag,
            parse_ques_option_weightage: option.option_weightage,
          })),
        };

        popData[currentQuestion.question_id] = popQuestionData;
        localStorage.setItem("POP", JSON.stringify(popData));
      }

      // Save tags for the current question
      tagsData[currentQuestion.question_id] = prepareTags();
      localStorage.setItem("TagsPOP", JSON.stringify(tagsData));

      // Move to the next question
      const nextIndex =
        questionsData.findIndex(
          (q) => q.question_id === currentQuestion.question_id
        ) + 1;
      if (nextIndex < questionsData.length) {
        setCurrentQuestion(questionsData[nextIndex]);
        setReviewedQuestions([
          ...reviewedQuestions,
          currentQuestion.question_id,
        ]);
      }

      // Reset the UI state
      setShowTwoInputs(false);
      setIsEditMode(false);
    }
  };

  const applyTagsToAll = () => {
    const existingTags = JSON.parse(localStorage.getItem("TagsPOP")) || {};
    const tagsForAll = prepareTags(); // Prepare the current tagging values

    // Apply the current tagging to all questions
    questionsData.forEach((question) => {
      existingTags[question.question_id] = tagsForAll.map((tag) => ({
        ...tag,
        parse_ques_set_id: selectedSetId, // Include selectedSetId
      }));
    });

    localStorage.setItem("TagsPOP", JSON.stringify(existingTags));
    // alert("Tags applied to all questions successfully!");
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div
        className="Container-messageBOX"
        onMouseEnter={pauseTimer}
        onMouseLeave={resumeTimer}
      >
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Tags applied to all questions successfully!</span>
        </div>
      </div>
    );
    setActiveImg(InterogativeImg);
  };

  const displayQuestionWithImages = (questionId) => {
    try {
      const questionData = JSON.parse(localStorage.getItem("POP"))?.[
        questionId
      ];
      const imagesData = JSON.parse(localStorage.getItem("ImagesPOP"))?.[
        questionId
      ];

      if (questionData && imagesData) {
        let questionText = questionData.question_text;
        imagesData.forEach((img) => {
          const imgTag = `<img src="${img.base64}" class="Img-RQ-QnsAns" alt="${img.name}" />`;
          questionText = questionText.replace(img.placeholder, imgTag);
        });
        return questionText;
      }
    } catch (error) {
      console.error("Error merging question and images:", error);
    }
    return null;
  };

  const replaceImagesWithPlaceholders = (text, questionId) => {
    const imgRegex =
      /<img src="(data:image\/[^;]+;base64,[^"]+)"[^>]*alt="([^"]+)"[^>]*>/g; // Match all base64 images
    const images = [];
    let match;
    let counter = 1; // Initialize a counter for sequential naming

    // Replace base64 images with placeholders
    const updatedText = text.replace(imgRegex, (match, src, alt) => {
      const uniqueName = alt ? alt : `image_${counter}`; // Use alt attribute if available, else fallback to sequential naming
      const placeholder = `#<${uniqueName}>#`; // Placeholder format

      images.push({ name: uniqueName, base64: src, placeholder }); // Store mapping
      counter++; // Increment counter for the next image
      return placeholder; // Replace the <img> tag with the placeholder
    });

    // Save images with placeholders into localStorage
    const existingImages = JSON.parse(localStorage.getItem("ImagesPOP")) || {};
    existingImages[questionId] = images; // Save images mapped to the current question ID
    localStorage.setItem("ImagesPOP", JSON.stringify(existingImages));

    return updatedText; // Return the text with placeholders
  };

  useEffect(() => {
    if (currentQuestion) {
      // Pre-select Course
      if (Array.isArray(coursesdata) && coursesdata.length > 0) {
        const selectedCourseObj = coursesdata.find(
          (course) => course.course_id === currentQuestion.course_tag_value_id
        );
        if (selectedCourseObj) {
          setValues({ course_id: selectedCourseObj.course_id });
          setDropdownKey(Date.now());
        }
      }

      // Pre-select Subject
      if (
        currentQuestion.subject_tag_value_id &&
        Array.isArray(subjects) &&
        subjects.length > 0
      ) {
        const selectedSubjectObj = subjects.find(
          (subject) =>
            subject.subject_id === currentQuestion.subject_tag_value_id
        );

        if (selectedSubjectObj && !selectedSubject) {
          // Set initial values only if no selection has been made
          setSelectedSubject(selectedSubjectObj.subject_id);
          setSelectedSubjectLabel(selectedSubjectObj.subject_name);
        }
      }

      // Pre-select Chapter
      if (
        currentQuestion.chapter_tag_value_id &&
        Array.isArray(chapters) &&
        chapters.length > 0
      ) {
        const selectedChapterObj = chapters.find(
          (chapter) =>
            chapter.chapter_id === currentQuestion.chapter_tag_value_id
        );
        if (selectedChapterObj) {
          setSelectedChapter(selectedChapterObj.chapter_id);
          setSelectedChapterLabel(selectedChapterObj.chapter_name);
        }
      }

      // Pre-select Topic
      if (
        currentQuestion.topic_tag_value_id &&
        Array.isArray(topics) &&
        topics.length > 0
      ) {
        const selectedTopicObj = topics.find(
          (topic) => topic.topic_id === currentQuestion.topic_tag_value_id
        );
        if (selectedTopicObj) {
          setTopicId(selectedTopicObj.topic_id);
          setSelectedTopicLabel(selectedTopicObj.topic_name);
        }
      }

      // Pre-select Difficulty Level
      const difficultyTag = currentQuestion.tags.find(
        (tag) => tag.tag_id === 8 // Assuming tag_id 8 represents Difficulty Level
      );

      if (difficultyTag) {
        setDropdownData((prevData) => ({
          ...prevData,
          [difficultyTag.tag_id]: difficultyTag.tag_value_id,
        })); // Set the pre-selected difficulty level in dropdownData
      }

      // Pre-select other tags (Dropdown type)
      currentQuestion.tags.forEach((tag) => {
        if (tag.tag_id !== 8) {
          // Skip Difficulty Level as it's already handled
          setDropdownData((prevData) => ({
            ...prevData,
            [tag.tag_id]: tag.tag_value_id,
          }));
        }
      });
    }
  }, [currentQuestion, coursesdata, subjects, chapters, topics]);

  return (
    <>
      <div className="Header-up">
        <span
          style={{
            color: "#2F2E40",
            fontSize: "30px",
            textTransform: "capitalize",
            paddingLeft: "30px",
          }}
        >
          Review Question{" "}
          <span style={{ color: "lightgrey" }}>{/* / {setNameSet} */}</span>
        </span>
        <div
          className="testreportcard-header-btn-container"
          style={{ marginRight: "30px" }}
        >
          {errorCount > 1 && ( // Show the button only if error count exceeds 1
            <button
              className="testreportcard-cancel-btn width-superseeding-2"
              onClick={clearLocalStorage}
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            >
              Clear Faulty Data
            </button>
          )}

          <button
            className="testreportcard-cancel-btn"
            style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
          >
            CANCEL
          </button>
          <button
            className="testreportcard-cancel-btn"
            style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            onClick={() => handleUpdateQuestion(false)} // false for SAVE
          >
            SAVE
          </button>
          <button
            className="testreportcard-create-btn width-superseeding-2"
            style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            onClick={handleSubmitSelectedReview} // Directly reference the function
          >
            Submit selected review
          </button>
        </div>
      </div>
      <div style={{ paddingLeft: "30px", paddingTop: "15px" }}>
        <div
          style={{
            width: "81vw",
            height: "30px",
            fontWeight: "600",
            backgroundColor: "#D6D6D6",
            alignContent: "center",
            paddingLeft: "8px",
            boxShadow: "4px 4px 4px 0px #00000040",
            border: "1px solid lightgrey",
          }}
        >
          <p style={{ color: "#424342" }}>QUESTION TAGGING</p>
        </div>
        <div
          style={{
            backgroundColor: "#FBFBFB",
            height: "auto",
            width: "81vw",
            boxShadow: "4px 4px 4px 0px #00000040",
            color: "#424342",
            padding: "10px",
            border: "1px solid lightgrey",
          }}
        >
          {isOpenTagging && (
            <div className="">
              <div className="grid-container-tagging">
                <div className="grid-item">
                  <AddOptionDropdwon
                    label="Set Name"
                    placeholder={setNameSet} // Correct way to pass the variable dynamically
                    setSelected={(selectedOption) => {
                      if (selectedOption) {
                        setSelectedSetName(selectedOption);
                        setSelectedSetId(selectedOption.id); // Update state with the selected ID
                      }
                    }}
                    options={setNames}
                    setOptions={setSetNames}
                    isRequired={true}
                    Height="auto"
                    OverFlow="auto"
                    minheight="300px"
                    disabled={true}
                  />
                </div>
                <div className="grid-item">
                  <DropDown
                    placeholder={selectedCourseLabel || "Select Course"} // Show initial value or default placeholder
                    label="Course"
                    setSelected={(selectedOption) => {
                      if (selectedOption) {
                        const selectedCourseObj = coursesdata.find(
                          (course) => course.course_id === selectedOption.id
                        );
                        setValues({ ...value, course_id: selectedOption.id }); // Update course ID
                        setSelectedCourseLabel(
                          selectedCourseObj?.course_description || ""
                        ); // Update the course label dynamically
                      } else {
                        // Retain initial values if no selection is made
                        const initialCourse = coursesdata.find(
                          (course) =>
                            course.course_id ===
                            currentQuestion.course_tag_value_id
                        );
                        setValues({
                          course_id: currentQuestion.course_tag_value_id,
                        }); // Retain the initial course ID
                        setSelectedCourseLabel(
                          initialCourse?.course_description || ""
                        ); // Retain the initial course label
                      }
                    }}
                    selectedLabel={selectedCourseLabel} // Display selected course label
                    options={
                      coursesdata
                        ? coursesdata.map((course) => ({
                            label: course.course_description,
                            id: course.course_id,
                          }))
                        : []
                    }
                    isRequired={true}
                  />
                </div>
                <div className="grid-item">
                  <DropDownUP
                    label="Subject"
                    placeholder={selectedSubjectLabel || "Select Subject"} // Show initial value or default placeholder
                    setSelected={(selectedOption) => {
                      if (selectedOption) {
                        setSelectedSubject(selectedOption.id); // Update the selected subject ID
                        setSelectedSubjectLabel(selectedOption.label); // Update the selected subject label
                      }
                    }}
                    selectedLabel={selectedSubjectLabel} // Pass the selected label for display
                    setSelectedLabel={setSelectedSubjectLabel} // Allow dynamic label update
                    options={subjects.map((subject) => ({
                      label: subject.subject_name,
                      id: subject.subject_id,
                    }))} // Subject options
                    isRequired={true}
                  />
                </div>
                <div className="grid-item">
                  <DropDownUP
                    label="Chapter"
                    placeholder={selectedChapterLabel || "Select Chapter"} // Show initial value or default placeholder
                    setSelected={setSelectedChapter}
                    selectedLabel={selectedChapterLabel}
                    setSelectedLabel={setSelectedChapterLabel}
                    options={chapters.map((chapter) => ({
                      label: chapter.chapter_name,
                      id: chapter.chapter_id,
                    }))}
                    isRequired={true}
                  />
                </div>
                <div className="grid-item">
                  <DropDownUP2
                    label="Topic"
                    placeholder={selectedTopicLabel || "Select Topic"} // Show initial value or a default placeholder
                    setSelected={(selectedOption) => {
                      if (selectedOption) {
                        setTopicId(selectedOption.id); // Update the selected topic ID
                        setSelectedTopicLabel(selectedOption.label); // Update the selected topic label
                      } else {
                        // Retain initial values if no selection is made
                        setTopicId(currentQuestion.topic_tag_value_id);
                        setSelectedTopicLabel(currentQuestion.topic_name);
                      }
                    }}
                    selectedLabel={selectedTopicLabel}
                    setSelectedLabel={setSelectedTopicLabel}
                    options={topics.map((topic) => ({
                      label: topic.topic_name,
                      id: topic.topic_id,
                    }))}
                  />
                </div>
                {/* Dropdowns */}
                {tags
                  .filter((tag) => tag.parse_tag_type === 1)
                  .map((tag) => (
                    <div className="grid-item" key={tag.parse_tag_id}>
                      <DropDown
                        label={tag.parse_tag_name}
                        setSelected={(selectedOption) =>
                          handleDropdownChange(tag, selectedOption)
                        }
                        options={tag.parse_tag_value.map((value) => ({
                          label: value.tag_value,
                          id: value.parse_tag_value_id,
                        }))}
                        value={dropdownData[tag.parse_tag_id]} // Pre-select based on tag_value_id
                      />
                    </div>
                  ))}
              </div>
              <div className="row-cs-uni">
                {/* Checkboxes */}
                {tags
                  .filter((tag) => tag.parse_tag_type === 2)
                  .map((tag) => (
                    <div style={{ marginLeft: "10px" }} key={tag.parse_tag_id}>
                      <div>
                        <input
                          style={{ marginRight: "6px" }}
                          type="checkbox"
                          id={`checkbox-${tag.parse_tag_id}`}
                        />
                        <label
                          style={{ marginRight: "40px" }}
                          htmlFor={`checkbox-${tag.parse_tag_id}`}
                        >
                          {tag.parse_tag_name}
                        </label>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="button-container">
                <button
                  className="simple-review-parser-btn"
                  onClick={applyTagsToAll}
                >
                  Apply to All
                </button>
              </div>
            </div>
          )}
        </div>

        <div style={{ paddingTop: "15px", color: "#424342" }}>
          <div
            style={{
              width: "81vw",
              height: "30px",
              fontWeight: "600",
              backgroundColor: "#D6D6D6",
              alignContent: "center",
              paddingLeft: "8px",
              paddingTop: "5px",
              boxShadow: "4px 4px 4px 0px #00000040",
              border: "1px solid lightgrey",
              display: "flex",
            }}
          >
            {" "}
            {currentQuestion && (
              <p style={{ color: "#424342", marginRight: "10px" }}>
                QUESTION # {currentQuestion.ques_no}
              </p>
            )}
            <img
              onClick={handleImageClick}
              src={isEditMode ? UndoBack : pencil}
              style={{
                width: "20px",
                height: "20px",
                cursor: "pointer",
                marginLeft: "10px",
              }}
              alt={isEditMode ? "Undo Changes" : "Edit Question"}
            />
          </div>
          {showTwoInputs ? (
            <div
              style={{
                width: "81vw",
                border: "1px solid lightgrey",
                boxShadow: "4px 4px 4px 0px #00000040",
                marginBottom: "20px",
              }}
            >
              {" "}
              <EditComponentPSQ
                questionText={currentQuestion?.question_text}
                optionFromAnotherPage={currentQuestion?.options}
                quesType={currentQuestion?.ques_type}
                quesNo={currentQuestion?.ques_no}
                setCurrentQuestion={setCurrentQuestion}
                fetchNewUpdatedDataValues={fetchNewUpdatedDataValues}
                handleReviewAndProceed={handleReviewAndProceed}
                globalImageCounter={globalImageCounter}
                setGlobalImageCounter={setGlobalImageCounter}
              />
            </div>
          ) : (
            <div
              style={{
                backgroundColor: "#FBFBFB",
                width: "81vw",
                height: "auto",
                boxShadow: "4px 4px 4px 0px #00000040",
                color: "#424342",
                padding: "10px",
                marginBottom: "20px",
                border: "1px solid lightgrey",
              }}
            >
              <div>
                {currentQuestion && (
                  <div>
                    <div>
                      <h3
                        className="Qns-RQ-Question"
                        style={{ marginBottom: "1px" }}
                      >
                        Question:
                      </h3>
                      <p
                        className="Qns-RQ-Question-2"
                        dangerouslySetInnerHTML={{
                          __html: processText(currentQuestion.question_text),
                        }}
                      ></p>
                    </div>
                    <ul>
                      {currentQuestion.options.map((option, index) => (
                        <li key={index} className="Qns-RQ-Options">
                          <input
                            type="radio"
                            name={`option-${currentQuestion.question_id}`}
                            checked={
                              option.parse_ques_option_correct_flag !==
                              undefined
                                ? option.parse_ques_option_correct_flag === 1
                                : option.option_correct_flag === 1
                            }
                            readOnly
                            style={{
                              marginRight: "10px",
                              cursor: "default",
                              accentColor: "#4CAF50",
                            }}
                          />
                          <span
                            className="Qns-RQ-Options-2"
                            dangerouslySetInnerHTML={{
                              __html: processText(option.option_text),
                            }}
                          ></span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <div style={{ width: "81vw", padding: "5px" }}>
          <div style={{ width: "81vw", padding: "5px" }}>
            <div className="row-space-between">
              <div className="flex-gap">
                <div>
                  <button className="grey-submitted-parser width-overwrite"></button>
                  <label className="C6A6A6A" style={{ marginLeft: "5px" }}>
                    Submitted
                  </label>
                </div>
                <div>
                  <button className="blue-review-parser width-overwrite"></button>
                  <label className="C6A6A6A" style={{ marginLeft: "5px" }}>
                    Reviewed
                  </label>
                </div>
                <div>
                  <button className="White-Not-review-parser width-overwrite"></button>
                  <label className="C6A6A6A" style={{ marginLeft: "5px" }}>
                    Not Reviewed
                  </label>
                </div>
              </div>

              <div className="flex-gap">
                <button
                  onClick={handlePreviousButtonClick}
                  className="simple-review-parser-btn"
                >
                  Previous
                </button>
                <button
                  className="simple-review-parser-btn"
                  onClick={handleDeleteQuestion}
                  disabled={currentQuestion?.status >= 4} // Disable if status is 4 or greater
                  style={{
                    cursor:
                      currentQuestion?.status >= 4 ? "not-allowed" : "pointer", // Change cursor style when disabled
                  }}
                >
                  {currentQuestion &&
                  deletedQuestions.includes(currentQuestion.question_id)
                    ? "Restore"
                    : "Delete"}
                </button>
                <button
                  onClick={handleSkipReview}
                  className="simple-review-parser-btn"
                >
                  Skip Review
                </button>
                <button
                  onClick={handleReviewAndProceed}
                  className="simple-review-parser-btn"
                  disabled={currentQuestion?.status >= 4} // Disable if status is 4 or greater
                  style={{
                    cursor:
                      currentQuestion?.status >= 4 ? "not-allowed" : "pointer", // Change cursor style when disabled
                  }}
                >
                  Review & Proceed
                </button>
              </div>
            </div>

            <div className="flex-gap width-superseeding Selection-Button-RQ">
              <div className="Selection-Button-RQ">
                {questionsData.map((question) => (
                  <button
                    style={{
                      margin: "3px",
                      opacity: isEditMode ? 0.5 : 1, // Reduce opacity when disabled
                      cursor: isEditMode ? "not-allowed" : "pointer", // Show 'not-allowed' cursor
                    }}
                    className={getButtonClass(question)}
                    key={question.question_id}
                    onClick={() => {
                      if (!isEditMode) {
                        handleButtonClick(question); // Only call if not in edit mode
                      }
                    }}
                    disabled={isEditMode} // Disable button when in edit mode
                  >
                    {question.ques_no}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PSQMain;
